// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'payback', 'payback Fallback'"},"className":"__className_fb3b45","variable":"__variable_fb3b45"};